export default {
    state: {
        lang: null,
    },
    mutations: {
        SET_LANG_DATA(state, payload) {
            state.lang = {
                ...payload,
                educationNav: {
                    appliance: "Применение",
                    contra: "Противопоказание",
                    volume: "Объем",
                    country: "Страна",
                    additional_information: "Дополнительная информация",
                    format: "Формат",
                    consistance: "Состав",
                    description: 'Описание',
                }
            };
        },
    },
    actions: {}
}